import React, { useContext, useEffect, useState } from 'react';
import { ConfigContext } from './Config';
import Login from '../Login';
import axios from 'axios';
import { Alert, AlertIcon, AlertTitle, AlertDescription, Box } from '@chakra-ui/react';

const AuthWrapper = ({ children }) => {
  const config = useContext(ConfigContext);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isProcessingToken, setIsProcessingToken] = useState(false);
  const [showChangePasswordTab, setShowChangePasswordTab] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleUserLoggedOut = () => {
      setIsAuthenticated(false);
    };

    const handleUserLoggedIn = () => {
      setIsAuthenticated(true);
    };

    window.addEventListener('userLoggedOut', handleUserLoggedOut);
    window.addEventListener('userLoggedIn', handleUserLoggedIn);

    return () => {
      window.removeEventListener('userLoggedOut', handleUserLoggedOut);
      window.removeEventListener('userLoggedIn', handleUserLoggedIn);
    };
  }, []);

  useEffect(() => {
    if (config.accessToken) {
      setIsAuthenticated(true);
    } else {
      setIsAuthenticated(false);
    }
  }, [config.accessToken]);

  useEffect(() => {
    const processPasswordResetToken = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const uid = urlParams.get('u');
      const timestamp = urlParams.get('t');
      const hash = urlParams.get('h');

      if (uid && timestamp && hash) {
        setIsProcessingToken(true);
        setError(null);
        try {
          const response = await axios.get(`${config.backendUrl}/user/get-token/${uid}/${timestamp}/${hash}`);
          if (response.data.status === 'success') {
            config.setAccessToken(response.data.access_token);
            setIsAuthenticated(true);
            setShowChangePasswordTab(true);
            // Remove the query parameters from the URL
            window.history.replaceState({}, document.title, window.location.pathname);
            // Dispatch a custom event for successful authentication
            window.dispatchEvent(new Event('userAuthenticated'));
          } else {
            setError(response.data.message || 'An error occurred while processing your request.');
          }
        } catch (error) {
          console.error('Error processing password reset token:', error);
          setError(error.response?.data?.message || error.message || 'An unexpected error occurred.');
        }
        setIsProcessingToken(false);
      }
    };

    processPasswordResetToken();
  }, [config]);

  if (!config || isProcessingToken) {
    return <div>Loading...</div>;
  }

  const handleLogin = async () => {
    setIsAuthenticated(true);
  };

  if (!isAuthenticated) {
    return (
      <Box>
        {error && (
          <Alert status="error" mb={4}>
            <AlertIcon />
            <AlertTitle mr={2}>Error</AlertTitle>
            <AlertDescription>{error}</AlertDescription>
          </Alert>
        )}
        <Login onLogin={handleLogin} />
      </Box>
    );
  }

  return (
    <Box>
      {error && (
        <Alert status="error" mb={4}>
          <AlertIcon />
          <AlertTitle mr={2}>Error</AlertTitle>
          <AlertDescription>{error}</AlertDescription>
        </Alert>
      )}
      {React.Children.map(children, child =>
        React.cloneElement(child, { showChangePasswordTab })
      )}
    </Box>
  );
};

export default AuthWrapper;